import { render, staticRenderFns } from "./TutorDashboardAcceptedShiftTransferModal.vue?vue&type=template&id=fc4375f4&scoped=true&"
import script from "./TutorDashboardAcceptedShiftTransferModal.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardAcceptedShiftTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorDashboardAcceptedShiftTransferModal.vue?vue&type=style&index=0&id=fc4375f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4375f4",
  null
  
)

export default component.exports